import { render, staticRenderFns } from "./TransporterRFQAdd.vue?vue&type=template&id=241f8832"
import script from "./TransporterRFQAdd.vue?vue&type=script&lang=js"
export * from "./TransporterRFQAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports